/* eslint-disable camelcase */
export default {
  title: 'Feedback form',
  subject: 'Subject of your message',
  body: 'Text of your message',
  sent_success: 'Your feedback has been sent successfully',
  send_another: 'Send another one',
  unknown_error: 'Unknown error while sending your feedback',
};
